import { Col, Container, Row } from "reactstrap";
import { useAppSelector } from "../../../reduxToolkit/hooks";
import { routes } from "../../../routers/routes";
import { FeaturedType } from "../../../types/HomeDemo";
import PropertyProductBox2 from "../../commonComponents/productBox/PropertyProductBox2";
import CommonHeader from "../common/CommonHeader";
import { FC } from "react";

const Featured: FC<FeaturedType> = ({ title, data, label }) => {
  const { productItem } = useAppSelector((state) => state.product);
  return (
    <section className="section-t-lg-space property2-featured-section section-b-lg-space">
      <Container>
        <CommonHeader title={title} headClass="title-style-1 title-style-6" subClass="horizontal-title" url={routes.Property.Grid.Property3Grid} view />
        <Row className="gy-xl-0 gy-md-4 g-3 justify-content-center">
          {productItem
            .filter(({ id }) => data.includes(id))
            .map((item, index) => (
              <Col xl="4" md="6" data-aos="fade-up" data-aos-duration={500 * (index + 1)} key={index}>
                <PropertyProductBox2 data={item} label={label} index={index} />
              </Col>
            ))}
        </Row>
      </Container>
    </section>
  );
};

export default Featured;
